import { useCallback, useEffect, useState } from 'react';

export const useMultiDayAccordionState = (blockCount: number) => {
  const [expandedIndex, setExpandedIndex] = useState(-1);

  useEffect(() => {
    if (blockCount === 0) {
      return;
    }

    if (expandedIndex >= blockCount) {
      setExpandedIndex(blockCount - 1);
    }
  }, [blockCount, expandedIndex]);

  const expandBlock = useCallback((index: number) => {
    setExpandedIndex(index);
  }, []);

  const handleAccordionChange = useCallback((index: number, expanded: boolean) => {
    setExpandedIndex(expanded ? index : -1);
  }, []);

  const isExpanded = useCallback((index: number) => expandedIndex === index, [expandedIndex]);

  return {
    expandBlock,
    handleAccordionChange,
    isExpanded,
  };
};
